import { StatusChips } from '@labrav/react-components'
import { useStyles } from './TitleDraftBadge.styles'

export const TitleDraftBadge = () => {
  const { classes } = useStyles()
  return (
    <div className={classes.root}>
      <StatusChips label="Draft" status="info" data-testid={'draft-status'} />
    </div>
  )
}
